import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { GA_CONFIG, trackCustomEvent, trackTimeOnPage } from '../config/analytics';

// Hook para gerenciar Google Analytics via GTM dataLayer
export const useGoogleAnalytics = () => {
  const location = useLocation();
  const startTimeRef = useRef(Date.now());

  // Rastrear mudanças de página (SPA)
  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
      measurement_id: GA_CONFIG.MEASUREMENT_ID,
    });

    if (startTimeRef.current) {
      const timeSpent = Math.floor((Date.now() - startTimeRef.current) / 1000);
      if (timeSpent > 0) {
        trackTimeOnPage(timeSpent);
      }
    }

    startTimeRef.current = Date.now();
  }, [location]);

  // Rastrear tempo na página quando o componente for desmontado
  useEffect(() => {
    return () => {
      if (startTimeRef.current) {
        const timeSpent = Math.floor((Date.now() - startTimeRef.current) / 1000);
        if (timeSpent > 0) {
          trackTimeOnPage(timeSpent);
        }
      }
    };
  }, []);

  const trackEvent = (action, category, label, value) => {
    trackCustomEvent(action, category, label, value);
  };

  const trackButtonClick = (buttonName, page) => {
    trackEvent(
      GA_CONFIG.EVENT_ACTIONS.CLICK,
      GA_CONFIG.EVENT_CATEGORIES.BUTTON,
      buttonName,
      page
    );
  };

  const trackFormSubmission = (formName, page) => {
    trackEvent(
      GA_CONFIG.EVENT_ACTIONS.SUBMIT,
      GA_CONFIG.EVENT_CATEGORIES.FORM,
      formName,
      page
    );
  };

  const trackDownload = (fileName, page) => {
    trackEvent(
      GA_CONFIG.EVENT_ACTIONS.DOWNLOAD,
      GA_CONFIG.EVENT_CATEGORIES.DOWNLOAD,
      fileName,
      page
    );
  };

  const trackExternalLink = (url, page) => {
    trackEvent(
      GA_CONFIG.EVENT_ACTIONS.CLICK,
      GA_CONFIG.EVENT_CATEGORIES.EXTERNAL_LINK,
      url,
      page
    );
  };

  const trackScroll = (percentage) => {
    trackEvent(
      GA_CONFIG.EVENT_ACTIONS.SCROLL,
      GA_CONFIG.EVENT_CATEGORIES.USER_ENGAGEMENT,
      `scroll_${percentage}%`,
      percentage
    );
  };

  const trackUserEngagement = (action, label) => {
    trackEvent(
      action,
      GA_CONFIG.EVENT_CATEGORIES.USER_ENGAGEMENT,
      label
    );
  };

  return {
    trackEvent,
    trackButtonClick,
    trackFormSubmission,
    trackDownload,
    trackExternalLink,
    trackScroll,
    trackUserEngagement
  };
};
